import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { first, map } from 'rxjs/operators';
import { PaymentCardDto } from '../dtos';
import { PaymentCardsFlowType, PaymentGateways } from '../enums';
import { deletePaymentCardAction, loadPaymentCardsAction, selectPaymentCardAction,  } from './payment-cards.actions';
import { IPaymentCardsFeature } from './payment-cards.feature.state';
import { failures, getCanPay, getDeletedPaymentCardResponse, getPaymentCards, getSelectedPaymentCard, isLoading } from './payment-cards.selectors';
import { CompanyConfigFacade, CompanyConfigType } from '@symphony-solo/domain/company-config/src';

const ALLOWED_PAYMENT_GATEWAYS = [PaymentGateways.AXEPT,PaymentGateways.AXEPT_TESTING];
@Injectable()
export class PaymentCardsFacade {
  public isLoading$ = this.store.select(isLoading);
  public failures$ = this.store.select(failures);
  public paymentCards$ = this.store.select(getPaymentCards);
  public canPay$ = this.store.select(getCanPay);
  public selectedPaymentCard$ = this.store.select(getSelectedPaymentCard).pipe(first());
  public getDeletedPaymentCardResponse$ = this.store.select(getDeletedPaymentCardResponse);

  public checkoutPaymentGatewayAvaliable$ = this.companyConfigFacade.companyConfigIndex$.pipe(
    map((companyConfigIndex) => {
      return (
        companyConfigIndex[CompanyConfigType.MyCardsPaymentCardsBoolean] &&
        ALLOWED_PAYMENT_GATEWAYS.includes(companyConfigIndex[CompanyConfigType.MyCardsPaymentCardsBoolean])
      );
    })
  );
  constructor(private store: Store<IPaymentCardsFeature>, private companyConfigFacade: CompanyConfigFacade) {}


  public loadPaymentCards(flow: PaymentCardsFlowType): void {
    this.store.dispatch(loadPaymentCardsAction({ flow }));
  }

  public selectPaymentCard(paymentCard: PaymentCardDto): void {
    this.store.dispatch(selectPaymentCardAction({ paymentCard }));
  }

  public deletePaymentCard(paymentCardID: number) {
    this.store.dispatch(deletePaymentCardAction({paymentCardID}));
  }
}
